module.exports = __webpack_public_path__ + "img/malta.7d5e72bf.svg";